import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { RelayPatchCachingServersDataProviderFactory } from '../factory/RelayPatchCachingServersDataProviderFactory';
import { RelayPatchCachingServersBaseDataProvider } from '../dataProvider/RelayPatchCachingServersBaseDataProvider';
import { DataGridItemsResponse, RelayCachingServer, RelayPatchCachingServersWebComponentSchema } from '../types';

export class RelayPatchCachingServersRepository extends BaseWebComponentRepository {
  public dataProviderFactory: RelayPatchCachingServersDataProviderFactory;
  public dataProvider: RelayPatchCachingServersBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new RelayPatchCachingServersDataProviderFactory(),
    });
  }

  async getDataForView(): Promise<RelayPatchCachingServersWebComponentSchema> {
    return this.dataProvider.getDataForView();
  }

  async getRelayServers(params: any): Promise<{ data: RelayCachingServer[] }> {
    return this.dataProvider.getRelayServers(params);
  }
}
